import { ChangeEvent, memo } from 'react';

import clsx from 'clsx';
import ReactToggle from 'react-toggle';

import classes from './Toggle.module.css';

export type TToggle = {
  checked?: boolean;
  checkedLabel?: string;
  className?: string;
  disabled?: boolean;
  name?: string;
  onChange: (changes: ChangeEvent<HTMLInputElement>) => void;
  size?: 'sm' | 'md';
  uncheckedLabel?: string;
};

function Toggle({
  name,
  checked = false,
  checkedLabel = 'Yes',
  uncheckedLabel = 'No',
  size = 'sm',
  className,
  disabled = false,
  onChange,
  ...otherProps
}: TToggle) {
  return (
    <ReactToggle
      name={name}
      data-testid={`toggle_${name}`}
      className={clsx(
        classes.root,
        classes[`toggle--${size}`],
        checked ? checkedLabel : uncheckedLabel,
        className
      )}
      checked={checked}
      icons={{
        checked: <span>{checkedLabel}</span>,
        unchecked: <span>{uncheckedLabel}</span>,
      }}
      disabled={disabled}
      onChange={onChange}
      aria-label={checked ? 'checked' : 'unchecked'}
      {...otherProps}
    />
  );
}

export default memo(Toggle);
